export const CookieKey = {
  AbTestingPopulation: 'abTestingPopulation',

  /** TrackingTool ** */
  AdsAllowed: 'adsAllowed',
  AnonymousAllowed: 'anonymousAllowed',
  StatsAllowed: 'statsAllowed',

  /** deviceId shape: **base:isAuthenticated:trackingKeyId** */
  DeviceId: 'deviceId',

  /** Hodor */
  HodorKey: 'hodorKey',

  /** Stored as a string */
  IsKidsProfile: 'isKidsProfile',

  Notification: 'notification',
  Offerzone: 'offerzone',
  PassId: 'passId',

  /** Legacy passId */
  PPassToken: 'p_pass_token',

  /** Stored as a string */
  ProfileId: 'profileId',

  SessionId: 'sessionId',
  Recommandations: 'recommandations',
  TokenCMS: 'tokenCMS',
  WhoIsWatchingDisabled: 'whoIsWatchingDisabled',
  WhoIsWatchingSession: 'whoIsWatchingSession',

  /** Akamai / Dynatrace */
  AkacdBlueGreenOneplayer: 'akacd_Blue_Green_Oneplayer',
  AkacdBlueGreenSPA: 'akacd_Blue_Green_SPA',
  AkacdPrThumborOrigin: 'akacd_pr_thumbor_origin',
  AkBmsc: 'ak_bmsc',
  AkSecurity: '_abck',
  Akbmi: 'bm_mi',
  Akbmsv: 'bm_sv',
  Akbmsz: 'bm_sz',
  DicoboId: 'dicbo_id',
  DtCookie: 'dtCookie',
  DtSa: 'dtSa',
  RxVisitor: 'rxVisitor',

  /** Cookies from the Didomi SDK */
  DidomiConsentString: 'euconsent-v2',
  DidomiToken: 'didomi_token',

  /** Others cookies */
  CookieBliink: 'Cookie_bliink',
  SplitCookie: 'split_cookie',
  UniqueEventToken: 'unique_event_token',
  Zone: 'zone',
  PageName: 'pageName',
  Segment: 'segment',
} as const;

/** Whitelist of cookies that should be preserved by the utag script
 *  These cookies must remain intact even when the user refuses consent
 */
export const cookieWhitelist = [
  CookieKey.AbTestingPopulation,
  CookieKey.AdsAllowed,
  CookieKey.AkacdBlueGreenOneplayer,
  CookieKey.AkacdBlueGreenSPA,
  CookieKey.AkacdPrThumborOrigin,
  CookieKey.Akbmi,
  CookieKey.AkBmsc,
  CookieKey.Akbmsv,
  CookieKey.Akbmsz,
  CookieKey.AkSecurity,
  CookieKey.AnonymousAllowed,
  CookieKey.CookieBliink,
  CookieKey.DeviceId,
  CookieKey.DicoboId,
  CookieKey.DidomiConsentString,
  CookieKey.DidomiToken,
  CookieKey.DtCookie,
  CookieKey.DtSa,
  CookieKey.HodorKey,
  CookieKey.IsKidsProfile,
  CookieKey.Notification,
  CookieKey.Offerzone,
  CookieKey.PageName,
  CookieKey.PassId,
  CookieKey.PPassToken,
  CookieKey.ProfileId,
  CookieKey.Recommandations,
  CookieKey.RxVisitor,
  CookieKey.Segment,
  CookieKey.SessionId,
  CookieKey.SplitCookie,
  CookieKey.StatsAllowed,
  CookieKey.TokenCMS,
  CookieKey.UniqueEventToken,
  CookieKey.WhoIsWatchingDisabled,
  CookieKey.WhoIsWatchingSession,
  CookieKey.Zone,
];

export type CookieKey = (typeof CookieKey)[keyof typeof CookieKey];

/** Duration in days for the deviceId cookie is 395 days = 13 months */
export const DEVICE_ID_COOKIE_DURATION = 395;
